"use client";

import React from "react";
import Link from "next/link";
import MiniProfile from "@/app/appointment/[id]/components/Appointment/components/MemberOpenings/components/StylistCard/MiniProfile";
import { stylistPhotoKey, type StylistCardData } from "@/lib/stylists";
import styles from "./stylists.module.scss";

export default function StylistProfileContent({
  stylist,
  locationNames,
  onClose,
}: {
  stylist: StylistCardData;
  locationNames: string[];
  onClose: () => void;
}) {
  return (
    <>
      <MiniProfile
        userId={stylist.memberId}
        username={stylist.username}
        name={stylist.name}
        bio={stylist.bio}
        photo={stylist.avatar ?? ""}
        workingSince={stylist.workingSince}
        profilePhotos={
          stylist.photos.length
            ? stylist.photos.map((photo) => ({
                ...photo,
                _id: photo.workPhotoId ?? photo.src,
                src: photo.src,
                alt: photo.alt,
                type: photo.type ?? "image",
                variants: [],
              }))
            : undefined
        }
        locationNames={locationNames}
        instagram={stylist.instagram}
        photoCategories={Object.fromEntries(
          stylist.photos.map((photo) => [
            stylistPhotoKey(photo.src),
            photo.serviceIds ?? [],
          ]),
        )}
        onClose={onClose}
      />
      <div className={styles.profileAction}>
        <Link href={`/stylists/${stylist.username}`} prefetch={false}>
          See availability
        </Link>
      </div>
    </>
  );
}
